import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { EntityMediaFragmentDoc } from '../../../../../features/messages/graphql/fragments/generated/MediaType';
export type GenerativeTaskFragment = { id: string, type: Types.GenerativeTaskTypeEnum, status: Types.GenerativeTaskStatusEnum, updatedAt: string, progress?: number | null, error?: { errorCode: Types.GenerativeTaskErrorCodeEnum, message?: string | null } | null, references?: Array<{ title?: string | null, referenceId: string, referenceType: Types.ReferenceTypeEnum, referenceUrl?: string | null, referenceParentId?: string | null, referenceParentType?: Types.ReferenceTypeEnum | null, referenceRootId?: string | null, referenceRootType?: Types.ReferenceRootTypeEnum | null, referenceMeta?: { id: string, name: string, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null } | { id: string, name: string, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null } | {} | null }> | null, input: { courseLessonFromTopic?: { lessonName?: string | null, lessonDescription?: string | null } | null, quizFromTopicAndCourseMaterials?: { lessonTopics?: Array<string> | null } | null }, result: { tasksFromPeerFeedback?: { records: Array<{ name: string }> } | null, skillNameAndDescription?: { records: Array<{ name: string, description: string }> } | null, skillRubricsFromSkillNameAndDescription?: { records: Array<{ description?: string | null, label: Types.SkillRubricLabelEnum, score?: number | null }> } | null, mindsetNameAndDescription?: { records: Array<{ name: string, description: string }> } | null, mindsetRubricsFromMindsetNameAndDescription?: { records: Array<{ label: Types.SkillRubricLabelEnum, description?: string | null, score?: number | null }> } | null, childObjectivesFromOKR?: { records: Array<{ name: string, description?: string | null }> } | null, childKRsFromOKR?: { records: Array<{ name: string, description?: string | null }> } | null, tasksFromKR?: { records: Array<{ name: string }> } | null, okrTemplates?: { records: Array<{ name: string, description?: string | null, childrenKRs?: Array<{ name: string }> | null }> } | null, transformText?: { text: string } | null, summaryFromMeetingInstance?: { text: string } | null, quizFromTopic?: { title: string, records: Array<{ singleChoiceQuestion?: { question: string, options: Array<string>, answer: number } | null, multiChoiceQuestion?: { question: string, options: Array<string>, answers: Array<number> } | null }> } | null, articleFromTopic?: { subtitle?: string | null, title: string, nodes?: Array<{ content: string }> | null } | null, optionsFromQuizQuestion?: { records: Array<{ value: string }> } | null, courseLessonFromTopic?: { text: string } | null, courseLessonStreamFromTopic?: { text: string } | null, chatWithKnowledgeBase?: { answer: string, followUpQuestions?: Array<string> | null, title?: string | null } | null, trainTheKnowledgeBase?: { answer: string, title?: string | null, description?: string | null, document?: string | null } | null, courseOutlineFromTopic?: { title: string, sections?: Array<{ title: string, lessons?: Array<{ title: string, description?: string | null }> | null }> | null } | null, goalsFromDepartment?: { goals?: Array<{ description?: string | null, title?: string | null }> | null, outcomes?: Array<{ description?: string | null, title?: string | null }> | null } | null, orgRolesFromDepartment?: { orgRoles?: Array<{ title?: string | null, description?: string | null }> | null } | null, departmentDescription?: { description?: string | null } | null, objectivesFromOrgRoleDepartment?: { objectivesByOrgRole: Array<{ orgRoleName: string, summary?: string | null, objectives?: Array<{ title?: string | null, description?: string | null }> | null }> } | null, mindsetsFromOrgRoleDepartment?: { mindsetsByOrgRole: Array<{ orgRoleName: string, mindsets?: Array<{ description?: string | null, title?: string | null }> | null }> } | null, activitiesFromOrgRoleDepartment?: { activitiesByOrgRole: Array<{ orgRoleName: string, activities?: Array<{ title?: string | null, description?: string | null, feature?: Types.FeatureInActivitiesForOrgRoleFromDepartmentEnum | null }> | null }> } | null, recommendIndividualOKRsInMGSA?: { recommendedOKRs?: Array<{ type: Types.OkrTypeEnum, status: Types.OkrStatusEnum, skills: Array<string>, ownerCategory: Types.ObjectiveTypeEnum, name: string, mindsets: Array<string>, instruction: string, goals: Array<string>, tasks?: Array<{ title: string, skills: Array<string>, mindsets: Array<string>, instruction: string, goals: Array<string> }> | null, keyResults?: Array<{ type: Types.OkrTypeEnum, status: Types.OkrStatusEnum, skills: Array<string>, name: string, mindsets: Array<string>, instruction: string, goals: Array<string>, tasks?: Array<{ title: string, skills: Array<string>, mindsets: Array<string>, instruction: string, goals: Array<string> }> | null, outcome: { targetValue?: number | null, startValue?: number | null, metric: Types.KeyResultMetricEnum } }> | null }> | null } | null, recommendDepartmentOKRsInMGSA?: { recommendedOKRs?: Array<{ goals: Array<string>, instruction: string, mindsets: Array<string>, name: string, ownerCategory: Types.ObjectiveTypeEnum, skills: Array<string>, status: Types.OkrStatusEnum, type: Types.OkrTypeEnum, keyResults?: Array<{ goals: Array<string>, instruction: string, mindsets: Array<string>, name: string, skills: Array<string>, status: Types.OkrStatusEnum, type: Types.OkrTypeEnum, outcome: { targetValue?: number | null, startValue?: number | null, metric: Types.KeyResultMetricEnum }, tasks?: Array<{ title: string, skills: Array<string>, mindsets: Array<string>, instruction: string, goals: Array<string> }> | null }> | null, tasks?: Array<{ title: string, skills: Array<string>, mindsets: Array<string>, instruction: string, goals: Array<string> }> | null }> | null } | null, skillsFromOrgRoleDepartment?: { skillsByOrgRole: Array<{ orgRoleName: string, skillGroups?: Array<{ skillGroupName?: string | null, skills?: Array<{ description?: string | null, expectedScore?: number | null, title?: string | null }> | null }> | null }> } | null, courseTitleAndDescriptionFromCourseMaterials?: { title: string, description?: string | null, coverUrl?: string | null, generatedCourseConfig?: { lessonCount?: number | null, sectionCount?: number | null } | null, aiConfig?: { threadId: string, aiFileConfigs: Array<{ vectorStoreId: string, fileId: string }> } | null, materialConfigs?: Array<{ materialInstruction?: string | null, materialSummary?: string | null, material: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } }> | null } | null, courseSkillsFromCourseMaterials?: { skillIds?: Array<string> | null } | null, courseOutcomesFromCourseMaterials?: { outcomes: Array<{ name: string, description?: string | null, childOutcomes: Array<{ name: string, description?: string | null }> }> } | null, courseChildOutcomesFromCourseMaterials?: { outcomes: Array<{ name: string, description?: string | null, childOutcomes: Array<{ name: string, description?: string | null }> }> } | null, courseOutlineWithOutcomesFromCourseMaterials?: { sections?: Array<{ title: string, outcomeIds?: Array<string> | null, lessons?: Array<{ title: string, outcomeIds?: Array<string> | null, description?: string | null, lessonType?: string | null, lessonDuration?: number | null, wordCountOfLesson?: number | null }> | null }> | null } | null, courseOutlineWithSkillsFromCourseMaterials?: { sections?: Array<{ skillIds?: Array<string> | null, title: string, lessons?: Array<{ title: string, skillIds?: Array<string> | null, description?: string | null }> | null }> | null } | null, regeneratedSectionOutlineWithSkillsFromCourseMaterials?: { sections?: Array<{ skillIds?: Array<string> | null, outcomeIds?: Array<string> | null, title: string, lessons?: Array<{ skillIds?: Array<string> | null, outcomeIds?: Array<string> | null, title: string, description?: string | null, lessonType?: string | null, lessonDuration?: number | null, wordCountOfLesson?: number | null }> | null }> | null } | null, regeneratedOutcomeOutlineFromCourseMaterials?: { outcomes: Array<{ name: string, description?: string | null, childOutcomes: Array<{ name: string, description?: string | null }> }> } | null, regeneratedSubOutcomeFromCourseMaterials?: { outcomes: Array<{ name: string, description?: string | null, childOutcomes: Array<{ name: string, description?: string | null }> }> } | null, generateImageForCourseLesson?: { url: string } | null, mindsetsFromUserDepartment?: { mindsets?: Array<{ description?: string | null, title?: string | null }> | null } | null, objectivesFromUserDepartment?: { summary?: string | null, objectives?: Array<{ title?: string | null, description?: string | null }> | null } | null, skillsFromUserDepartment?: { skillGroups?: Array<{ skillGroupName?: string | null, skills?: Array<{ expectedScore?: number | null, title?: string | null, description?: string | null }> | null }> | null } | null, activitiesFromUserDepartment?: { activities?: Array<{ title?: string | null, feature?: Types.FeatureInActivitiesForOrgRoleFromDepartmentEnum | null, description?: string | null }> | null } | null, videoGeneration?: { videoUrl?: string | null, videoPlaylist?: { videoUrl: string, totalDurationInSeconds?: number | null, captionUrl?: string | null } | null, videos?: Array<{ videoUrl?: string | null, hlsUrl?: string | null, captionUrl?: string | null, thumbnailUrl?: string | null, status: string }> | null } | null, generateVideoLessonScript?: { videoScript?: string | null, fileSummary?: string | null } | null, videoSlideSelection?: { slides?: Array<{ name: string, transcript: string, variables?: string | null, heygenTemplateId: string, slideTemplateId: string }> | null } | null, switchVideoSlideTemplate?: { slide?: { name: string, transcript: string, variables?: string | null, heygenTemplateId: string, slideTemplateId: string } | null } | null, okrBuilderExtractFromDocuments?: { objectives?: Array<string> | null, keyResults?: Array<string> | null, goalIds?: Array<string> | null, skillIds?: Array<string> | null, mindsetIds?: Array<string> | null, userIds?: Array<string> | null, fileSummaries?: Array<string> | null } | null, roleplayFromMaterials?: { title?: string | null, description?: string | null, learnerRole?: string | null, situation?: string | null, objections?: Array<string> | null, difficultyType?: Types.RoleplayDifficultyTypesEnum | null, conversationTimeLimit?: number | null, coverUrl?: string | null, urlDescription?: string | null, criteriaAndRubrics?: Array<{ title?: string | null, description?: string | null }> | null, avatarConfig?: { avatarId?: string | null, name?: string | null, gender?: string | null, role?: string | null, relationship?: string | null, background?: string | null, company?: string | null, previewSentence?: string | null, voiceId?: string | null } | null, materialConfigs?: Array<{ materialInstruction?: string | null, materialSummary?: string | null, material: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } }> | null } | null, okrBuilderGenerateObjectives?: { objectives: Array<{ title: string, description?: string | null, dueDate?: string | null, ownerId?: string | null, skillIds?: Array<string> | null, mindsetIds?: Array<string> | null, goalIds?: Array<string> | null, cycleId?: string | null, type: Types.OkrTypeEnum, owner?: { name?: string | null, id: string, profilePicture?: string | null, isManager: boolean } | null, okrCycle?: { name: string, id: string, startDate: string, dueDate: string, createdAt: string } | null, goals?: Array<{ createdAt: string, name: string, id: string }> | null, skills: Array<{ id: string, name: string, createdAt: string }>, mindsets?: Array<{ id: string, name: string, createdAt: string }> | null }> } | null } };


export type GenerativeTaskFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const GenerativeTaskFragmentDoc = /*#__PURE__*/ gql`
    fragment GenerativeTaskFragment on GenerativeTaskType {
  id
  type
  status
  updatedAt
  progress
  error {
    errorCode
    message
  }
  references {
    title
    referenceId
    referenceType
    referenceUrl
    referenceParentId
    referenceParentType
    referenceRootId
    referenceRootType
    referenceMeta {
      ... on CourseContentType {
        id
        name
        cover {
          url
        }
        type
      }
      ... on ArticleContentType {
        id
        name
        cover {
          url
        }
        type
      }
    }
  }
  input {
    courseLessonFromTopic {
      lessonName
      lessonDescription
    }
    quizFromTopicAndCourseMaterials {
      lessonTopics
    }
  }
  result {
    tasksFromPeerFeedback {
      records {
        name
      }
    }
    skillNameAndDescription {
      records {
        name
        description
      }
    }
    skillRubricsFromSkillNameAndDescription {
      records {
        description
        label
        score
      }
    }
    mindsetNameAndDescription {
      records {
        name
        description
      }
    }
    mindsetRubricsFromMindsetNameAndDescription {
      records {
        label
        description
        score
      }
    }
    childObjectivesFromOKR {
      records {
        name
        description
      }
    }
    childKRsFromOKR {
      records {
        name
        description
      }
    }
    tasksFromKR {
      records {
        name
      }
    }
    okrTemplates {
      records {
        name
        description
        childrenKRs {
          name
        }
      }
    }
    transformText {
      text
    }
    summaryFromMeetingInstance {
      text
    }
    quizFromTopic {
      title
      records {
        singleChoiceQuestion {
          question
          options
          answer
        }
        multiChoiceQuestion {
          question
          options
          answers
        }
      }
    }
    articleFromTopic {
      nodes {
        content
      }
      subtitle
      title
    }
    optionsFromQuizQuestion {
      records {
        value
      }
    }
    courseLessonFromTopic {
      text
    }
    courseLessonStreamFromTopic {
      text
    }
    chatWithKnowledgeBase {
      answer
      followUpQuestions
      title
    }
    trainTheKnowledgeBase {
      answer
      title
      description
      document
    }
    courseOutlineFromTopic {
      title
      sections {
        title
        lessons {
          title
          description
        }
      }
    }
    goalsFromDepartment {
      goals {
        description
        title
      }
      outcomes {
        description
        title
      }
    }
    orgRolesFromDepartment {
      orgRoles {
        title
        description
      }
    }
    departmentDescription {
      description
    }
    objectivesFromOrgRoleDepartment {
      objectivesByOrgRole {
        orgRoleName
        summary
        objectives {
          title
          description
        }
      }
    }
    mindsetsFromOrgRoleDepartment {
      mindsetsByOrgRole {
        orgRoleName
        mindsets {
          description
          title
        }
      }
    }
    activitiesFromOrgRoleDepartment {
      activitiesByOrgRole {
        orgRoleName
        activities {
          title
          description
          feature
        }
      }
    }
    recommendIndividualOKRsInMGSA {
      recommendedOKRs {
        type
        tasks {
          title
          skills
          mindsets
          instruction
          goals
        }
        status
        skills
        ownerCategory
        name
        mindsets
        keyResults {
          type
          tasks {
            title
            skills
            mindsets
            instruction
            goals
          }
          status
          skills
          outcome {
            targetValue
            startValue
            metric
          }
          name
          mindsets
          instruction
          goals
        }
        instruction
        goals
      }
    }
    recommendDepartmentOKRsInMGSA {
      recommendedOKRs {
        goals
        instruction
        keyResults {
          goals
          instruction
          mindsets
          name
          outcome {
            targetValue
            startValue
            metric
          }
          skills
          status
          tasks {
            title
            skills
            mindsets
            instruction
            goals
          }
          type
        }
        mindsets
        name
        ownerCategory
        skills
        status
        tasks {
          title
          skills
          mindsets
          instruction
          goals
        }
        type
      }
    }
    skillsFromOrgRoleDepartment {
      skillsByOrgRole {
        orgRoleName
        skillGroups {
          skillGroupName
          skills {
            description
            expectedScore
            title
          }
        }
      }
    }
    courseTitleAndDescriptionFromCourseMaterials {
      title
      description
      coverUrl
      generatedCourseConfig {
        lessonCount
        sectionCount
      }
      aiConfig {
        aiFileConfigs {
          vectorStoreId
          fileId
        }
        threadId
      }
      materialConfigs {
        material {
          ...EntityMedia
        }
        materialInstruction
        materialSummary
      }
    }
    courseSkillsFromCourseMaterials {
      skillIds
    }
    courseOutcomesFromCourseMaterials {
      outcomes {
        name
        description
        childOutcomes {
          name
          description
        }
      }
    }
    courseChildOutcomesFromCourseMaterials {
      outcomes {
        name
        description
        childOutcomes {
          name
          description
        }
      }
    }
    courseOutlineWithOutcomesFromCourseMaterials {
      sections {
        title
        outcomeIds
        lessons {
          title
          outcomeIds
          description
          lessonType
          lessonDuration
          wordCountOfLesson
        }
      }
    }
    courseOutlineWithSkillsFromCourseMaterials {
      sections {
        lessons {
          title
          skillIds
          description
        }
        skillIds
        title
      }
    }
    regeneratedSectionOutlineWithSkillsFromCourseMaterials {
      sections {
        lessons {
          skillIds
          outcomeIds
          title
          description
          lessonType
          lessonDuration
          wordCountOfLesson
        }
        skillIds
        outcomeIds
        title
      }
    }
    regeneratedOutcomeOutlineFromCourseMaterials {
      outcomes {
        name
        description
        childOutcomes {
          name
          description
        }
      }
    }
    regeneratedSubOutcomeFromCourseMaterials {
      outcomes {
        name
        description
        childOutcomes {
          name
          description
        }
      }
    }
    generateImageForCourseLesson {
      url
    }
    mindsetsFromUserDepartment {
      mindsets {
        description
        title
      }
    }
    objectivesFromUserDepartment {
      summary
      objectives {
        title
        description
      }
    }
    skillsFromUserDepartment {
      skillGroups {
        skills {
          expectedScore
          title
          description
        }
        skillGroupName
      }
    }
    activitiesFromUserDepartment {
      activities {
        title
        feature
        description
      }
    }
    videoGeneration {
      videoUrl
      videoPlaylist {
        videoUrl
        totalDurationInSeconds
        captionUrl
      }
      videos {
        videoUrl
        hlsUrl
        captionUrl
        thumbnailUrl
        status
      }
    }
    generateVideoLessonScript {
      videoScript
      fileSummary
    }
    videoSlideSelection {
      slides {
        name
        transcript
        variables
        heygenTemplateId
        slideTemplateId
      }
    }
    switchVideoSlideTemplate {
      slide {
        name
        transcript
        variables
        heygenTemplateId
        slideTemplateId
      }
    }
    okrBuilderExtractFromDocuments {
      objectives
      keyResults
      goalIds
      skillIds
      mindsetIds
      userIds
      fileSummaries
    }
    roleplayFromMaterials {
      title
      description
      learnerRole
      situation
      criteriaAndRubrics {
        title
        description
      }
      avatarConfig {
        avatarId
        name
        gender
        role
        relationship
        background
        company
        previewSentence
        voiceId
      }
      objections
      difficultyType
      conversationTimeLimit
      coverUrl
      materialConfigs {
        material {
          ...EntityMedia
        }
        materialInstruction
        materialSummary
      }
      urlDescription
    }
    okrBuilderGenerateObjectives {
      objectives {
        title
        description
        dueDate
        ownerId
        skillIds
        mindsetIds
        goalIds
        cycleId
        owner {
          name
          id
          profilePicture
          isManager
        }
        okrCycle {
          name
          id
          startDate
          dueDate
          createdAt
        }
        goals {
          createdAt
          name
          id
        }
        skills {
          id
          name
          createdAt
        }
        mindsets {
          id
          name
          createdAt
        }
        type
      }
    }
  }
}
    `;